import { render, staticRenderFns } from "./addSEOPage.vue?vue&type=template&id=45b9d066&lang=pug"
import script from "./addSEOPage.vue?vue&type=script&lang=js"
export * from "./addSEOPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports